const Footer =() => {
    return(
        <div className={"footer-content "}>
            <img width={300} src={process.env.PUBLIC_URL+"/images/yeni-obbheryerde.png"} alt="Logo"/>
        </div>
    )
}

export default Footer;